export default __webpack_public_path__ + "static/media/book.b03420b1.png";